<script>
import axios from "axios";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

/**
 * Register component
 */
export default {
   page: {
      title: "Register",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
   },
   data() {
      return {
         hub: {
               client_name: "",
               client_mobile: "",
               client_email: "",
               state_id: "",
               district_id: "",

               business_name: "",
               business_mobile: "",
               business_email: "",
               business_state_id: "",
               business_district_id: "",
               ownership_id: "",
               business_type_id: "",
               password: "",
               report_password: "",
            },

            client_country_code: '91',
            client_sec_country_code: '91',
            business_country_code: '91',

            types: [],
            ownerships: [],
            states: [],
            districts: [],
            business_districts: [],

            accept_terms: false,

            errors: {},
            token: {},

      };
   },

   created() {
      this.fetchStates();
      this.fetchBusinessTypes();
      this.fetchOwnerships();
   },

   methods: {
      numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         alphaDotSpacesOnly(event) {
         let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32) || (keyCode == 46))  {
                  return;
            } else {
               event.preventDefault();
            }
         },

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         fetchStates() {
            let url = "/api/register/states";         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.states = responseData.states;
               })
               .catch((err) => console.log(err));
         },

         fetchDistricts() {
            let url = "/api/register/districts?state_id=" + this.hub.state_id;         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.districts = responseData.districts;
               })
               .catch((err) => console.log(err));
         },

         fetchBusinessDistricts() {
            let url = "/api/register/districts?state_id=" + this.hub.business_state_id;         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.business_districts = responseData.districts;
               })
               .catch((err) => console.log(err));
         },

         fetchOwnerships() {
            let url = "/api/register/ownerships";         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.ownerships = responseData.ownerships;
               })
               .catch((err) => console.log(err));
         },

         fetchBusinessTypes() {
            let url = "/api/register/businessTypes";         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.types = responseData.types;
               })
               .catch((err) => console.log(err));
         },
      register() {

         if(!this.accept_terms) {
            this.$swal("", "Please accept the terms and conditions to continue", "error");
         } else {
        
            let formData = new FormData();
            formData.append("client_name", this.hub.client_name);
            formData.append("client_mobile", this.hub.client_mobile);
            formData.append("client_email", this.hub.client_email);
            formData.append("state_id", this.hub.state_id);
            formData.append("district_id", this.hub.district_id);

            formData.append("business_name", this.hub.business_name);
            formData.append("business_mobile", this.hub.business_mobile);
            formData.append("business_email", this.hub.business_email);
            formData.append("business_state_id", this.hub.business_state_id);
            formData.append("business_district_id", this.hub.business_district_id);
            formData.append("ownership_id", this.hub.ownership_id);
            formData.append("business_type_id", this.hub.business_type_id);
            formData.append("password", this.hub.password);
            formData.append("report_password", this.hub.report_password);
            const config = {
               headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json",
               },
             };

            this.errors = {};
            //let url = "https://ourworks.co.in/vaahan-connect/public/api/register/create";
            let url = "https://api.vahanconnect.com/api/register/create";
            axios
            .post(url, formData, config)
            .then((response) => {
               //console.log(response);
               this.$router.push({ name: "login" });
               this.$swal("", response.data.message, "success");
               
            })
            .catch((error) => {
               //console.log(error);
               if (error.response) {
                  
                  this.errors = error.response.data.message;
                  if (error.response.data) {
                     //this.$swal("", this.errors[0], "error");
                  } else {
                     this.errorMessage = error.message;
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.errorMessage = error.message;
                  this.$swal("", "Something went wrong", "error");
               }
               
            });
         }
      },
   }
  
};
</script>

<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-10">
            <div class="card overflow-hidden">
               <div class="bg-soft bg-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">Register</h5>
                           <p>Get your Vahan Connect account now.</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <!-- <img src="@/assets/images/profile-img.png" alt class="img-fluid"/> -->
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                     <router-link tag="a" to="/">
                        <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-dark">
                              <img src="@/assets/images/logo.svg" alt class="rounded-circle" height="34" />
                           </span>
                        </div>
                     </router-link>
                  </div>
            
                  <b-form class="p-2" @submit.prevent="register()">
                     <div class="row">
                        <div class="col-lg-12">
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                              <h4 class="card-title">Client Details</h4>
                              <div class="row">
                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Name <span class="text-danger">*</span></label>
                                    <b-form-input v-model="hub.client_name" v-bind:class="{ 'is-invalid': Boolean(errors.client_name) }" maxlength="100"  @keypress="alphaDotSpacesOnly"></b-form-input>

                                    <div v-for="(val, index) in errors.client_name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Mobile <span class="text-danger">*</span></label>
                                    <b-input-group prepend="+91">
                                       <b-form-input v-model="hub.client_mobile"  v-bind:class="{ 'is-invalid': Boolean(errors.client_mobile) }" maxlength="10" @keypress="numbersOnly"></b-form-input>
                                    </b-input-group>

                                    <div v-for="(val, index) in errors.client_mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Email <span class="text-danger">*</span></label>
                                    <b-form-input type="email" v-model="hub.client_email" v-bind:class="{ 'is-invalid': Boolean(errors.client_email) }" maxlength="100"></b-form-input>

                                    <div v-for="(val, index) in errors.client_email" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>State <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.state_id" v-bind:class="{ 'is-invalid': Boolean(errors.state_id) }" @change="fetchDistricts(), hub.district_id=''">
                                       <option value="">Select State</option>
                                       <option :value="state.id" v-for="state in states" :key="state.id">{{state.state}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.state_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>District <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.district_id" v-bind:class="{ 'is-invalid': Boolean(errors.district_id) }">
                                       <option value="">Select District</option>
                                       <option :value="district.id" v-for="district in districts" :key="district.id">{{district.district}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.district_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>
                              </div>
                           </b-card>
                        </div>

                        <div class="col-lg-12">
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                              <h4 class="card-title">Business Details</h4>
                              <div class="row">                           

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Business Name <span class="text-danger">*</span></label>
                                    <b-form-input v-model="hub.business_name" v-bind:class="{ 'is-invalid': Boolean(errors.business_name) }" maxlength="100"></b-form-input>

                                    <div v-for="(val, index) in errors.business_name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Mobile <span class="text-danger">*</span></label>
                                    <b-input-group prepend="+91">
                                       <b-form-input v-model="hub.business_mobile" v-bind:class="{ 'is-invalid': Boolean(errors.business_mobile) }" maxlength="10" @keypress="numbersOnly"></b-form-input>
                                    </b-input-group>

                                    <div v-for="(val, index) in errors.business_mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Business Type <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.business_type_id" v-bind:class="{ 'is-invalid': Boolean(errors.business_type_id) }">
                                       <option value="">Select Type</option>
                                       <option :value="type.id" v-for="type in types" :key="type.id">{{type.type}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.business_type_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>
                              
                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Email <span class="text-danger">*</span></label>
                                    <b-form-input type="email" v-model="hub.business_email" v-bind:class="{ 'is-invalid': Boolean(errors.business_email) }" maxlength="100"></b-form-input>

                                    <div v-for="(val, index) in errors.business_email" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>                         

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>State <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.business_state_id" v-bind:class="{ 'is-invalid': Boolean(errors.business_state_id) }" @change="fetchBusinessDistricts(), hub.business_district_id=''">
                                       <option value="">Select State</option>
                                       <option :value="state.id" v-for="state in states" :key="state.id">{{state.state}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.business_state_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>District <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.business_district_id" v-bind:class="{ 'is-invalid': Boolean(errors.business_district_id) }">
                                       <option value="" v-if="hub.business_district_id==''">Select District</option>
                                       <option :value="district.id" v-for="district in business_districts" :key="district.id">{{district.district}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.business_district_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Ownership <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="hub.ownership_id" v-bind:class="{ 'is-invalid': Boolean(errors.ownership_id) }">
                                       <option value="">Select Ownership</option>
                                       <option :value="ownership.id" v-for="ownership in ownerships" :key="ownership.id">{{ownership.ownership}}</option>
                                    </select>

                                    <div v-for="(val, index) in errors.ownership_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Password <span class="text-danger">*</span></label>
                                    <b-form-input type="password" v-model="hub.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }" maxlength="16" @keypress="noSpaces"></b-form-input>

                                    <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-4 mb-3">
                                    <label>Report Password <span class="text-danger">*</span></label>
                                    <b-form-input type="password" v-model="hub.report_password" v-bind:class="{ 'is-invalid': Boolean(errors.report_password) }" maxlength="16" @keypress="noSpaces"></b-form-input>

                                    <div v-for="(val, index) in errors.report_password" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>
                           
                              </div>
                           </b-card>
                        </div>
                     </div>
                     <div class="mt-0 d-grid">
                        <b-form-checkbox v-model="accept_terms" :value="true" :unchecked-value="false"><span class="ms-2">I accept the <a href="https://vahanconnect.com/terms-and-conditions" target="_blank">terms and conditions</a></span></b-form-checkbox>

                        <b-button type="submit" variant="primary" class="btn-block mt-3"
                           >Register</b-button>
                     </div>
                  </b-form>

                  <!-- <div class="mt-4 text-center">
                     <p class="mb-0">
                        By registering you agree to the Vahan Connect
                        <a href="javascript: void(0);" class="text-primary">Terms of Use</a></p>
                  </div> -->
               </div>
               <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="text-center">
               <p>Already have an account ?
                  <router-link tag="a" to="/login" class="fw-medium text-primary">Login</router-link>
               </p>
               <p>© {{ new Date().getFullYear() }} VAHAN CONNECT. Powered by Auticto</p>
            </div>
         </div>
         <!-- end col -->
      </div>
      <!-- end row -->
   </Layout>
</template>

<style lang="scss" module></style>
